<template>
  <div class="file-preview">
    <el-dialog ref="dialogPreview" class="ms-dialog preview-dialog" width="900px" center :visible.sync="visible"
               :fullscreen="true" :close-on-click-modal="false" @opened="opened()" @close="close()"
               :destroy-on-close="true">
      <div slot="title">
        <span class="el-dialog__title">{{ fileName }}</span>
      </div>
      <div class="content">
        <div class="left common">
          <el-button v-if="httpUrl.length > 1" icon="el-icon-arrow-left" circle @click="previewLeft"></el-button>
        </div>
        <div class="middle">
          <div class="preview-image" id="preview-image" v-if="showVisible[0].visible">
            <img draggable="true" ref="removeImage" @mousedown.capture="mouseDownClickImg" @mouseup.stop="mouseupClick"
                 id="el-image" class="el-image" :src="$store.state.file + httpUrl[index].filePath"/>
          </div>
          <div v-else-if="showVisible[1].visible" class="el-pdf">
            <embed type="application/pdf"
                   :src="$store.state.file + httpUrl[index].filePath + '#scrollbar=0&toolbar=0&navpanes=0'"
                   controls="console" align="top"/>
          </div>
          <div v-else-if="showVisible[2].visible" class="preview-dialog-doc">
            <div class="preview-dialog-doc-item">
              <svg class="preview-doc-icon" v-html="svgData.iconWordSvg"/>
              <p class="title">暂不支持word文件在线预览，请下载后进行查阅</p>
              <el-button class="zwx-button zwx-button-icontext-32" icon="el-icon-download" @click.native="downLoadFile">
                下载
              </el-button>
            </div>
          </div>
          <div v-else-if="showVisible[3].visible" class="preview-dialog-doc">
            <div class="preview-dialog-doc-item">
              <svg class="preview-excel-icon" v-html="svgData.iconExcelSvg"/>
              <p class="title">暂不支持excel文件在线预览，请下载后进行查阅</p>
              <el-button class="zwx-button zwx-button-icontext-32" icon="el-icon-download" @click.native="downLoadFile">
                下载
              </el-button>
            </div>
          </div>
          <div v-else-if="showVisible[4].visible" class="preview-dialog-doc">
            <div class="preview-dialog-doc-item">
              <svg class="preview-mp4-icon" v-html="svgData.iconMp4Svg"/>
              <p class="title">暂不支持mp4文件在线预览，请下载后进行查阅</p>
              <el-button class="zwx-button zwx-button-icontext-32" icon="el-icon-download" @click.native="downLoadFile">
                下载
              </el-button>
            </div>
          </div>
          <div v-else-if="showVisible[5].visible" class="preview-dialog-doc">
            <div class="preview-dialog-doc-item">
              <svg class="preview-zip-icon" v-html="svgData.iconZipSvg"/>
              <p class="title">暂不支持zip文件在线预览，请下载后进行查阅</p>
              <el-button class="zwx-button zwx-button-icontext-32" icon="el-icon-download" @click.native="downLoadFile">
                下载
              </el-button>
            </div>
          </div>
        </div>
        <div class="footer" v-if="showVisible[0].visible || showVisible[1].visible">
          <el-tooltip class="item" effect="dark" content="下载" placement="top">
            <el-button @click.native="downLoadFile"><i class="outline chis-icon-outline-download icon-file-download"></i></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="顺时针旋转90°" placement="top">
            <el-button @click.capture="imgRightRotate" v-show="showVisible[0].visible"><i class="outline chis-icon-outline-rotate-right icon-right-rotate"></i></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="逆时针旋转90°" placement="top">
            <el-button @click.capture="imgLeftRotate" v-show="showVisible[0].visible"><i class="outline chis-icon-outline-rotate-left icon-left-rotate"></i></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="放大" placement="top">
            <el-button icon="el-icon-zoom-in" @click.capture="imgUpSize" v-show="showVisible[0].visible"/>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="缩小" placement="top">
            <el-button icon="el-icon-zoom-out" @click.capture="imgDownSize" v-show="showVisible[0].visible"></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="还原尺寸" placement="top">
            <el-button @click.capture="imgResetSize" v-show="showVisible[0].visible"><i class="outline chis-icon-outline-size-reset icon-size-reset"></i></el-button>
          </el-tooltip>
        </div>
        <div class="right common">
          <el-button v-if="httpUrl.length > 1" icon="el-icon-arrow-right" circle @click="previewRight"></el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import svgData from './svg-data.js'
export default {
  name: 'FilePreview',
  data() {
    return {
      api: this.$store.state.api,
      visible: false,
      svgData: svgData,
      offHeight: '',
      size: 50,
      rotate: 0,
      offsetLeft: 0,
      offY: 0,
      offsetTop: 0,
      fileName: '',
      showVisible: [{visible: false}, {visible: false}, {visible: false}, {visible: false}, {visible: false}, {visible: false}],
      httpUrl: [],
      mouseMoveClick: null,
    }
  },
  created() {
  },
  mounted() {
  },
  computed: {},
  methods: {
    opened() {
      this.$emit('opened')
    },
    close() {
      this.offHeight = ''
      this.size = 50
      this.rotate = 0
      this.offsetLeft = 0
      this.offY = 0
      this.offsetTop = 0
      this.fileName = 0
      this.showVisible = [{visible: false}, {visible: false}, {visible: false}, {visible: false}, {visible: false}, {visible: false}]
      this.httpUrl = 0
      this.mouseMoveClick = null
      this.$emit('close')
    },
    cancel() {
      this.visible = false
    },
    /**
     * 初始化组件
     */
    initPreviewFile(file, index) {
      this.visible = true
      this.httpUrl = file || []
      this.index = index || 0
      this.getTypeOfFile(this.index)
    },
    /**
     * 图片顺时针旋转
     */
    imgRightRotate() {
      this.initMove()
      if (this.rotate >= 360) {
        this.rotate = 0
      }
      this.rotate = this.rotate + 90
      let img = document.getElementById('el-image')
      img.style.transform = 'rotate(' + this.rotate + 'deg)'
    },
    /**
     * 图片逆时针旋转
     */
    imgLeftRotate() {
      this.initMove()
      if (this.rotate <= -360) {
        this.rotate = 0
      }
      this.rotate = this.rotate - 90
      let img = document.getElementById('el-image')
      img.style.transform = 'rotate(' + this.rotate + 'deg)'
    },
    /**
     * 图片放大到200%
     */
    imgUpSize() {
      this.initMove()
      if (this.size >= 100) {
        this.size = 100
      } else {
        this.size = this.size + 10
      }
      var img = document.getElementById('el-image')
      img.style.width = this.size + '%'
    },
    /**
     * 图片缩小到20%
     */
    imgDownSize() {
      this.initMove()
      if (this.size <= 20) {
        this.size = 20
      } else {
        this.size = this.size - 10
      }
      var img = document.getElementById('el-image')
      img.style.width = this.size + '%'
    },
    /**
     * 图片还原到初始尺寸
     */
    imgResetSize() {
      this.size = 50
      var img = document.getElementById('el-image')
      img.removeAttribute('style')
      img.onmousemove = null
    },
    /**
     * 点击图片拖拽之后的初始化
     */
    initMove() {
      var img = document.getElementById('el-image')
      img.onmousemove = null
      img.style.position = ''
      img.style.left = ''
      img.style.top = ''
    },
    /**
     * 获取图片和外部div的尺寸
     */
    getCss(elmen, css) {
      return parseInt(window.getComputedStyle ? window.getComputedStyle(elmen, null)[css] : obj.currentStyle[css])
    },
    /**
     * 鼠标按下获取图片
     */
    mouseDownClickImg(event) {
      event.preventDefault()
      var elImage = document.getElementById('el-image')
      var previewImage = document.getElementById('preview-image')
      var previewImageWidthSize = this.getCss(previewImage, 'width')
      var previewImageHeightSize = this.getCss(previewImage, 'height')
      var elImageWidthSize, elImageHeightSize, x, y
      x = event.clientX - elImage.offsetLeft
      y = event.clientY - elImage.offsetTop
      // 根据旋转的角度 重新定义图片的宽高
      if (Math.abs(this.rotate) === 90 || Math.abs(this.rotate) === 270) {
        elImageHeightSize = this.getCss(elImage, 'width')
        elImageWidthSize = this.getCss(elImage, 'height')
      } else {
        elImageWidthSize = this.getCss(elImage, 'width')
        elImageHeightSize = this.getCss(elImage, 'height')
      }
      if (previewImageWidthSize - elImageWidthSize > 0 && previewImageHeightSize - elImageHeightSize > 0) {
        document.getElementById('preview-image').onmousemove = null
        return
      }
      previewImage.onmousemove = function (event) {
        event.stopPropagation()
        event.preventDefault()
        var moveX = event.clientX - x
        var moveY = event.clientY - y
        if (previewImageWidthSize - elImageWidthSize < 0) {
          if (moveX <= previewImageWidthSize - elImageWidthSize) {
            moveX = previewImageWidthSize - elImageWidthSize
          }
          if (moveX > 0) {
            moveX = 0
          }
          if (moveY >= 0) {
            moveY = 0
          }
          if (moveY <= previewImageHeightSize - elImageHeightSize) {
            moveY = previewImageHeightSize - elImageHeightSize
          }
        } else {
          if ((Math.abs(this.rotate) === 90 || Math.abs(this.rotate) === 270) && previewImageHeightSize - elImageHeightSize < 0) {
            var averageNum = parseInt(parseFloat((elImageWidthSize - elImageHeightSize) / 2))
            if (moveX <= averageNum) {
              moveX = averageNum
            }
            if (moveX > previewImageWidthSize - elImageWidthSize + averageNum) {
              moveX = previewImageWidthSize - elImageWidthSize + averageNum
            }
            if (moveY <= previewImageHeightSize - elImageHeightSize - averageNum) {
              moveY = previewImageHeightSize - elImageHeightSize - averageNum
            }
            if (moveY > Math.abs(averageNum)) {
              moveY = Math.abs(averageNum)
            }
          } else {
            if (moveX >= previewImageWidthSize - elImageWidthSize) {
              moveX = previewImageWidthSize - elImageWidthSize
            }
            if (moveX < 0) {
              moveX = 0
            }
            if (moveY >= 0) {
              moveY = 0
            }
            if (moveY <= previewImageHeightSize - elImageHeightSize) {
              moveY = previewImageHeightSize - elImageHeightSize
            }
          }
        }
        elImage.style.position = 'absolute'
        elImage.style.left = moveX + 'px'
        elImage.style.top = moveY + 'px'
        elImage.style.cursor = 'pointer'
      }
    },
    mouseupClick(event) {
      event.preventDefault()
      document.getElementById('preview-image').onmousemove = null
      document.getElementById('el-image').style.cursor = 'auto'
    },
    /**
     * 获取当前文件的名称
     */
    getFileName(fileName, type) {
      if (type === '1') {
        return fileName
      } else {
        fileName = fileName.split('.')
        return fileName[0]
      }
    },
    /**
     * 判断文件类型
     * .jpg .pdf .docx .excel .mp4
     */
    getTypeOfFile(index) {
      var fileList = this.httpUrl
      if (!fileList.length) return
      this.fileName = this.getFileName(fileList[this.index].fileName, '1')
      var typeList = fileList[index].filePath.split('.')
      var type = typeList[typeList.length - 1]
      type = type.toLowerCase()
      this.resetShowVisible()
      if (type === 'jpg' || type === 'jpeg' || type === 'png') {
        this.showVisible[0].visible = true
        this.$nextTick(function () {
          this.imgResetSize()
        })
      } else if (type === 'pdf') {
        this.showVisible[1].visible = true
      } else if (type === 'doc' || type === 'docx') {
        this.showVisible[2].visible = true
      } else if (type === 'xls' || type === 'xlsx') {
        this.showVisible[3].visible = true
      } else if (type === 'mp4') {
        this.showVisible[4].visible = true
      } else if (type === 'zip' || type === 'rar' || type === '7z') {
        this.showVisible[5].visible = true
      }
    },
    /**
     * 文件类型初始显示皆为false
     */
    resetShowVisible() {
      var fileVisible = this.showVisible
      for (var i = 0; i < fileVisible.length; i++) {
        fileVisible[i].visible = false
      }
    },
    /**
     * 点击向前按钮 切换预览文件
     */
    previewLeft() {
      this.size = 50
      if (this.index === 0) {
        this.index = this.httpUrl.length - 1
        this.getTypeOfFile(this.index)
        return
      }
      this.index--
      this.getTypeOfFile(this.index)
    },
    /**
     * 点击向后按钮 切换预览文件
     */
    previewRight() {
      this.size = 50
      if (this.index === this.httpUrl.length - 1) {
        this.index = 0
        this.getTypeOfFile(this.index)
        return
      }
      this.index++
      this.getTypeOfFile(this.index)
    },
    /**
     * 下载文件
     */
    downLoadFile() {
      this.$system.downloadUrlFile(this.fileName, this.$store.state.api + this.httpUrl[this.index].filePath)
    },
  },
}
</script>
<style lang="less">
.file-preview .el-dialog {
  background: none !important;
}

.file-preview .el-dialog__header {
  width: 100%;
  padding: 0 !important;
  height: 64px !important;
  line-height: 64px !important;
  box-sizing: border-box !important;
  background: #484848 !important;
  position: relative !important;
  text-align: center !important;
}

.file-preview .el-dialog__header .el-dialog__title {
  font-size: 18px !important;
  color: #fff !important;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.file-preview .el-dialog-header__btn {
  position: absolute !important;
  top: 50% !important;
  right: 38px !important;
}

.file-preview .el-dialog__header .el-dialog__headerbtn {
  font-size: 25px !important;
  top: 17px !important;
  right: 17px !important;
  border-radius: 4px !important;
  width: 30px !important;
  height: 30px !important;
}

.file-preview .el-dialog__header .el-dialog__headerbtn .el-dialog__close {
  opacity: 0.8 !important;
  color: #fff !important;
}

.file-preview .el-dialog__header .el-dialog__headerbtn:hover {
  background: #7f7f7f !important;
}

.file-preview .el-dialog__header .el-dialog__headerbtn:hover .el-dialog__close {
  color: #fff !important;
}

.file-preview .el-dialog__body {
  padding: 0 !important;
  height: calc(100% - 64px) !important;
  overflow: hidden !important;
  background: none !important;
}

.file-preview .content {
  padding: 0 !important;
  height: 100% !important;
}

.file-preview .content .common {
  position: absolute !important;
  top: calc(50% - 64px) !important;
}

.left {
  left: 65px;
}

.right {
  right: 65px;
}

.v-modal {
  opacity: 0.3 !important;
}

.file-preview .common .el-button {
  width: 90px !important;
  height: 90px !important;
  background: rgba(6 b, 6 b, 6 b, 0.5) !important;
  border: none !important;
}

.file-preview .el-button .el-icon-arrow-right,
.file-preview .el-button .el-icon-arrow-left {
  font-size: 34px !important;
  font-weight: bold !important;
  color: #fff !important;
}

.file-preview .content .left .el-button:hover,
.file-preview .content .right .el-button:hover {
  background: #979797 !important;
}

.file-preview .middle {
  width: 100%;
  height: 100%;
  max-width: calc(100% - 440px) !important;
  max-height: calc(100% - 64px) !important;
  margin: auto !important;
  overflow: hidden !important;
  flex: 1;
  position: relative;
}

.file-preview .footer .el-button > i {
  font-size: 16px;
  color: #fff;
  text-align: center;
}

.file-preview .middle .preview-image {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.file-preview .middle .el-image {
  width: 50%;
  height: auto;
  object-fit: inherit;
}

.file-preview .middle .el-pdf {
  width: 100% !important;
  height: 100% !important;
  overflow: hidden !important;
}

.file-preview .middle embed {
  position: absolute !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  width: 100% !important;
  height: 100% !important;
  overflow: auto !important;
  z-index: 1 !important;
}

.file-preview .preview-dialog-doc {
  width: 100%;
  height: 100%;
  color: #fff;
}

.file-preview .preview-dialog-doc .preview-dialog-doc-item {
  position: absolute;
  top: calc(50% - 120px);
  left: calc(50% - 150px);
  text-align: center;
}

.file-preview .preview-dialog-doc .title {
  font-size: 16px;
  line-height: 16px;
  color: #ffffff;
  margin: 15px 0 25px 0;
}

.file-preview .preview-dialog-doc .preview-pdf-icon,
.file-preview .preview-dialog-doc .preview-doc-icon,
.file-preview .preview-dialog-doc .preview-mp4-icon,
.file-preview .preview-dialog-doc .preview-zip-icon,
.file-preview .preview-dialog-doc .preview-excel-icon {
  display: inline-block;
  width: 120px;
  vertical-align: sub;
}

.preview-dialog-doc .zwx-button-icontext-32 {
  padding: 0 18px !important;
}

.file-preview .preview-dialog-doc .el-button {
  background: #bababa;
  border-radius: 4px;
  color: #000;
}

.file-preview .content .footer {
  width: 100%;
  height: 64px;
  line-height: 56px;
  text-align: center;
  background: rgba(0, 0, 0, 0.15);
}

.file-preview .footer .el-button {
  width: 32px !important;
  height: 32px !important;
  background: #585858 !important;
  border-radius: 4px !important;
  line-height: 32px !important;
  border: none !important;
  padding: 0 !important;
}

.file-preview .footer .el-button:hover {
  background: #7f7f7f !important;
  border: 1px solid #7f7f7f !important;
}

.icon-left-rotate,
.icon-right-rotate,
.icon-size-reset,
.icon-file-download,
.el-icon-zoom-in,
.el-icon-zoom-out {
  width: 16px !important;
  height: 16px !important;
  margin-bottom: 4px;
  color: #FFFFFF;
}

</style>
